export default __webpack_public_path__ + "static/media/seashell-box-closed.4ccf7fbf.svg";